import { render, staticRenderFns } from "./FPageTecPassword.vue?vue&type=template&id=65cee65d&scoped=true&"
import script from "./FPageTecPassword.vue?vue&type=script&lang=js&"
export * from "./FPageTecPassword.vue?vue&type=script&lang=js&"
import style0 from "./FPageTecPassword.vue?vue&type=style&index=0&id=65cee65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cee65d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib'
installComponents(component, {VSheet})
